<div class="container {{ OBJ_LNG_NAME }} insertEdit">
  <div class="dialog-header">
    <h1 mat-dialog-title>{{ (aktuell.id ? 'allgemein.bearbeiten' : 'allgemein.neu') | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
      <mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
    </h1>
    <button class="close-button" mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
  </div>
  <mat-dialog-content>
    <form #inserteditForm="ngForm" class="{{ OBJ_LNG_NAME }} inserteditForm">

      <p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>

      <mat-form-field class="full-width">
        <input matInput #reihenfolge="ngModel" [(ngModel)]="aktuell.reihenfolge" type="number" name="reihenfolge"
          [min]="1" [disabled]="dialogrunningajaxcall" required />
        <mat-label>{{ OBJ_LNG_NAME+'.reihenfolge' | translate:locale.language }}</mat-label>
        <mat-hint
          *ngIf="reihenfolge.errors && (reihenfolge.dirty || reihenfolge.touched) && (reihenfolge.errors.required || reihenfolge.errors.min)">{{
          'allgemein.validierung.nichtleerzwischen' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.reihenfolge' |
          translate:locale.language, von: '1', bis: holeMaxReihenfolge() } }}</mat-hint>
        <mat-hint *ngIf="aktuell.reihenfolge > holeMaxReihenfolge() && (reihenfolge.dirty || reihenfolge.touched)">{{
          'allgemein.validierung.nichtleerzwischen' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.reihenfolge' |
          translate:locale.language, von: '1', bis: holeMaxReihenfolge() } }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput #icon="ngModel" [(ngModel)]="aktuell.icon" name="icon"
          [placeholder]="aktuell.icon ? ('icon.typ' | translate:locale.language) : ('allgemein.auswählen' | translate:locale.language:{ typ: 'icon.typ' | translate:locale.language })"
          (click)="zeigeIconauswahlMaske()" />
        <button *ngIf="aktuell.icon" matPrefix mat-icon-button type="button"
          (click)="zeigeIconauswahlMaske()"><mat-icon>{{ aktuell.icon }}</mat-icon></button>
        <mat-hint *ngIf="icon.errors && (icon.dirty || icon.touched) && icon.errors.required">{{
          'allgemein.validierung.auswählen' | translate:locale.language:{ unbestimmt: 'icon.artikel.unbestimmt' |
          translate:locale.language, typ: 'icon.typ' | translate:locale.language } }}</mat-hint>
        <mat-label>{{ OBJ_LNG_NAME+'.icon' | translate:locale.language }}</mat-label>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput #sprachschluessel="ngModel" [(ngModel)]="aktuell.tempSprachSchluessel" type="text"
          name="sprachschluessel" maxlength="244" [disabled]="dialogrunningajaxcall"
          pattern="^[a-zA-Z][\w\-]*[\w](\.[\w\-]+)*([\w]|(\.#))$" required />
        <mat-label>{{ OBJ_LNG_NAME+'.sprachschluessel' | translate:locale.language }}</mat-label>
        <span matPrefix>menue.</span>
        <mat-hint
          *ngIf="sprachschluessel.errors && (sprachschluessel.dirty || sprachschluessel.touched) && sprachschluessel.errors.pattern">{{
          'allgemein.validierung.nichtsprachschlüssel' | translate:locale.language:{ typ:
          OBJ_LNG_NAME+'.sprachschluessel' | translate:locale.language } }}</mat-hint>
        <mat-hint
          *ngIf="sprachschluessel.errors && (sprachschluessel.dirty || sprachschluessel.touched) && sprachschluessel.errors.required">{{
          'allgemein.validierung.nichtleer' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.sprachschluessel' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="sprachschluessel.value" align="end">{{ sprachschluessel.value.length + 5 }} / 249</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput #recht="ngModel" [(ngModel)]="aktuell.tempSprachSchluessel" type="text" name="recht"
          disabled="true" />
        <mat-label>{{ 'kernrecht.typ' | translate:locale.language }}</mat-label>
        <span matPrefix>recht.menue.</span>
        <mat-hint *ngIf="recht.value" align="end">{{ recht.value.length + 11 }} / 255</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-select class="full-width" [(ngModel)]="aktuell.vater" name="vater" [disabled]="dialogrunningajaxcall"
          multiple="false" [compareWith]="compareMitId">
          <!--		<mat-label>{{ 'allgemein.auswählen' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.elternteil' | translate:locale.language } }}</mat-label>-->
          <mat-option>{{ OBJ_LNG_NAME+'.kein_elternteil' | translate:locale.language }}</mat-option>
          <mat-option *ngFor="let i of aktuell.eltern" [value]="i">{{ i.treePath + ' - ' +
            i.md2DataTableSort_Sprachschluessel }}</mat-option>
        </mat-select>
        <mat-label *ngIf="aktuell.vater != null">{{ OBJ_LNG_NAME+'.elternteil' | translate:locale.language
          }}</mat-label>
        <mat-label *ngIf="aktuell.vater == null">{{ 'allgemein.auswählen' | translate:locale.language:{ typ:
          OBJ_LNG_NAME + '.elternteil' | translate:locale.language } }}</mat-label>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-select [(ngModel)]="aktuell.ziel" name="ziel" [disabled]="dialogrunningajaxcall" required multiple="false">
          <!--<mat-label>{{ 'allgemein.auswählen' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.ziel' | translate:locale.language } }}</mat-label>-->
          <mat-option *ngFor="let i of aktuell.zieltypen" [value]="i">{{ i }}</mat-option>
        </mat-select>
        <mat-label *ngIf="aktuell.ziel != null">{{ OBJ_LNG_NAME+'.ziel' | translate:locale.language }}</mat-label>
        <mat-label *ngIf="aktuell.ziel == null">{{ 'allgemein.auswählen' | translate:locale.language:{ typ: OBJ_LNG_NAME
          + '.ziel' | translate:locale.language } }}</mat-label>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-select class="full-width" [(ngModel)]="aktuell.urlschema" name="urlschema"
          [disabled]="ladedaten || dialogrunningajaxcall" (selectionChange)="changeAktuelleUrl()" multiple="false">
          <!--<mat-label>{{ 'allgemein.auswählen' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.urlschema' | translate:locale.language } }}</mat-label>-->
          <!--        <mat-option>{{ 'allgemein.auswählen' | translate:locale.language:{ typ: OBJ_LNG_NAME + '.urlschema' | translate:locale.language } }}</mat-option>-->
          <mat-option>{{ OBJ_LNG_NAME+'.keine_urlschema' | translate:locale.language }}</mat-option>
          <mat-option [value]="'http'">http://</mat-option>
          <mat-option [value]="'https'">https://</mat-option>
        </mat-select>
        <mat-label *ngIf="aktuell.urlschema != null && aktuell.urlschema !==''">{{ OBJ_LNG_NAME + '.urlschema' |
          translate:locale.language }}</mat-label>
        <mat-label *ngIf="aktuell.urlschema == null || aktuell.urlschema === ''">{{ 'allgemein.auswählen' |
          translate:locale.language:{ typ: OBJ_LNG_NAME + '.urlschema' | translate:locale.language } }}</mat-label>
      </mat-form-field>

      <mat-form-field class="full-width" *ngIf="aktuell != null && aktuell.aktuellurlmax != null">
        <input matInput #host="ngModel" [(ngModel)]="aktuell.host" type="text" name="host"
          [maxLength]="aktuell.aktuellurlmax.host" [disabled]="ladedaten || dialogrunningajaxcall"
          (keyup)="changeAktuelleUrl()" pattern="(www\.)?[a-zA-Z0-9][\-a-zA-Z0-9@:%._\+~#=]{0,255}" />
        <mat-label>{{ OBJ_LNG_NAME + '.host' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="host.errors && (host.dirty || host.touched) && host.errors.pattern">{{
          'allgemein.validierung.formatfalsch' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.host' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="host.value" align="end">{{ host.value.length }} / {{ aktuell.aktuellurlmax.host }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width" *ngIf="aktuell != null && aktuell.aktuellurlmax != null">
        <span matPrefix>/</span>
        <input matInput #pfad="ngModel" [(ngModel)]="aktuell.pfad" type="text" name="pfad"
          [maxLength]="aktuell.aktuellurlmax.pfad" [disabled]="ladedaten || dialogrunningajaxcall"
          (keyup)="changeAktuelleUrl()" pattern="([\/a-zA-Z0-9=\?&\+@_\-]+)*" />
        <mat-label>{{ OBJ_LNG_NAME + '.pfad' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="pfad.errors && (pfad.dirty || pfad.touched) && pfad.errors.pattern">{{
          'allgemein.validierung.formatfalsch' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.pfad' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="pfad.value" align="end">{{ pfad.value.length }} / {{ aktuell.aktuellurlmax.pfad }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width" *ngIf="aktuell != null && aktuell.aktuellurlmax != null">
        <span matPrefix>?</span>
        <input matInput #query="ngModel" [(ngModel)]="aktuell.query" type="text" name="query"
          [maxLength]="aktuell.aktuellurlmax.query" [disabled]="ladedaten || dialogrunningajaxcall"
          (keyup)="changeAktuelleUrl()" pattern="([^\/?=&]+(=[^\/?=&]*)?&?)*" />
        <mat-label>{{ OBJ_LNG_NAME + '.query' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="query.errors && (query.dirty || query.touched) && query.errors.pattern">{{
          'allgemein.validierung.formatfalsch' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.query' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="query.value" align="end">{{ query.value.length }} / {{ aktuell.aktuellurlmax.query
          }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width" *ngIf="aktuell != null && aktuell.aktuellurlmax != null">
        <span matPrefix>#</span>
        <input matInput #fragment="ngModel" [(ngModel)]="aktuell.fragment" type="text" name="fragment"
          [maxLength]="aktuell.aktuellurlmax.fragment" [disabled]="ladedaten || dialogrunningajaxcall"
          (keyup)="changeAktuelleUrl()" pattern="([\w\-]+)?" />
        <mat-label>{{ OBJ_LNG_NAME + '.fragment' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="fragment.errors && (fragment.dirty || fragment.touched) && fragment.errors.pattern">{{
          'allgemein.validierung.formatfalsch' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.fragment' |
          translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="fragment.value" align="end">{{ fragment.value.length }} / {{ aktuell.aktuellurlmax.fragment
          }}</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput #url="ngModel" [ngModel]="aktuell.url" type="text" name="url" disabled="true"
          pattern="^https?:\/\/(www\.)?[a-zA-Z0-9][\-a-zA-Z0-9@:%\._\+~#=]{0,255}\.[a-z]{2,4}\b([\-a-zA-Z0-9@:%_\+\.~#\?&\/=]*)" />
        <mat-label>{{ OBJ_LNG_NAME + '.url' | translate:locale.language }}</mat-label>
        <mat-hint *ngIf="url.errors && url.errors.pattern">{{ 'allgemein.validierung.formatfalsch' |
          translate:locale.language:{ typ: OBJ_LNG_NAME+'.fragment' | translate:locale.language } }}</mat-hint>
        <mat-hint *ngIf="url.value" align="end">{{ url.value.length }} / 255</mat-hint>
      </mat-form-field>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">

    <button mat-raised-button type="button" (click)="close()" [disabled]="dialogrunningajaxcall">{{
      'allgemein.abbrechen' | translate:locale.language }}</button>
    <button mat-raised-button type="submit" (click)="speichernAendern()" color="primary"
      [disabled]="!inserteditForm.form.valid || dialogrunningajaxcall">
      <mat-spinner *ngIf="dialogrunningajaxcall"></mat-spinner>
      {{ (dialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : (neu ? 'allgemein.neu' : 'allgemein.speichern')) |
      translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
    </button>

  </mat-dialog-actions>
</div>